import {ReplaySubject} from 'rxjs';
import type {SpotPair, MarginPair} from '@/types';

export const spot$ = new ReplaySubject<SpotPair | MarginPair>(1);
